export default __webpack_public_path__ + "static/media/tensrbetter2.39cb9749.svg";